/* -------------------------------------------------------------------------- *
 * Form Validation (via Parsley) *
 * -------------------------------------------------------------------------- */

/* globals $ */

// Parsley plugin options
const options = {
    errorClass: 'has-error',
    errorsContainer(field) {
        return field.$element.closest('.form__field');
    },
    errorTemplate: '<li class="form__error"></li>',
    errorsWrapper: '<ul class="listReset"></ul>',
    requiredMessage: 'This field is required.',
    successClass: '',
};

/* ------------- *
 * Module Export *
 * ------------- */

const Validate = {
    init() {
        const forms = document.querySelectorAll('.js-validate');
        const forms_arr = Array.from(forms);

        // Add Parsley validation to forms
        forms_arr.forEach((form) => {
            form.setAttribute('novalidate', '');
            $(form).parsley(options);
        });
    },
};

export default Validate;
